<div [ngClass]="getClassNames()">
  <span *ngIf="icon" class="ub-label__icon">{{ icon }}</span>
  <span *ngIf="label" class="ub-label__description">{{ label }}:</span>
  <span *ngIf="text" class="ub-label__text">{{ text }}</span>

  <span class="ub-label__text">
    <ng-content select="[text]"></ng-content>
  </span>
</div>
